import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';
import { Project } from './project';
import { AuthenticationService } from '../_shared/services/authentication.service';
import { environment } from '../../environments/environment';
/**
 * Created by caterina on 04-05-17.
 */
@Injectable()
export class ProjectService {
  private url = `${environment.apiUrl}/project/`;

  constructor(private http: Http,
    private authService: AuthenticationService) {
  }

  /*TODO handle errors correctly*/
  getRootProjects() {
    return this.http.get(this.url, this.authService.getAuthOptions()).map(res => res.json());
  }

  getFolderProjects(folderId: number) {
    const url = this.url + '?parent=' + folderId;
    return this.http.get(url, this.authService.getAuthOptions()).map(res => res.json());
  }

  get(id: number) {
    const url = `${this.url}${id}/`;
    return this.http.get(url, this.authService.getAuthOptions()).map(res => res.json());
  }

  delete(id: number) {
    const url = `${this.url}${id}/`;
    return this.http.delete(url, this.authService.getAuthOptions())
      .map((res) => res.json())
      .catch(this.handleError);
  }

  update(project: Project) {
    const url = `${this.url}${project.id}/`;
    return this.http.put(url, JSON.stringify(project), this.authService.getAuthOptions())
      .map((res) => res.json());
  }

  create(project: Project) {
    return this.http.post(this.url, JSON.stringify(project), this.authService.getAuthOptions())
      .map((res) => res.json());
  }

  handleError(err: Response) {
    console.log(err.status);
    return Observable.throw(err);
  }

  getDXF(id): Observable<any> {
    const url = `${this.url}${id}/dxf/`;
    return this.http.get(url, this.authService.getAuthOptions())
      .map(res => new Blob([res.text()], { type: 'application/dxf' }))
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getDXFLining(id): Observable<any> {
    const url = `${this.url}${id}/dxf_linings/`;
    return this.http.get(url, this.authService.getAuthOptions())
      .map(res => new Blob([res.text()], { type: 'application/dxf' }))
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  getEXCEL(id, cubicationType): Observable<any> {
    const url = `${this.url}${id}/${cubicationType}xls/`;
    console.log(url)
    let FILE_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    return this.http
      .get(url, this.authService.getExcelOptions())
      .map(res => {
        let fileBlob = res.blob();
        return new Blob([fileBlob], { type: FILE_TYPE })
      })
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

}



// WEBPACK FOOTER //
// ./src/app/project/project.service.ts